import { route } from 'react-router-typesafe-routes/dom';
import { yup } from 'react-router-typesafe-routes/yup';
import * as Yup from 'yup';

export const ActivityLogRoutes = {
	ACTIVITY_LOG: route('activity-log', {}),
};
